import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const deleteCourse = id => {
  return dispatch => {
    dispatch({ type: "DELETE_COURSE_LOADING" });
    api
      .courseDelete(id)
      .then(resp => {
        dispatch(operationSucceeded(id));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "DeleteCourseErrorAlertTitle",
          "Virhe poistaessa muuta koulutusta",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = (id) => ({
  type: "DELETE_COURSE_SUCCEEDED",
  payload: { course: { courseId: id, rowId: id } }
});

const operationFail = () => ({
  type: "DELETE_COURSE_FAIL"
});
